import React, { useState, useEffect } from "react";
import Menu from "../component/menu/Menu";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { baseurl } from "./BaseURL/BaseURL";
import review from "../Images/Group 30.png";
import axios from "axios";
import { useQueries, useQuery } from "@tanstack/react-query";
import Footer from "./Footer";

function ProductPage() {
  const [filteredSaleCards, setFilteredSaleCards] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("English books");
  const [loading, setLoading] = useState(false);
  const [newArrival, setNewArrival] = useState([]);

  // React Query queries for each category
  const englishQuery = useQuery({
    queryKey: ["saleCategory", "english"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-englishcategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  console.log("here is the filter card", filteredSaleCards);

  const urduQuery = useQuery({
    queryKey: ["saleCategory", "urdu"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Urducategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const novalQuery = useQuery({
    queryKey: ["saleCategory", "noval"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Novalcategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const seasonalQuery = useQuery({
    queryKey: ["saleCategory", "seasonal"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Seasonalcategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const cssQuery = useQuery({
    queryKey: ["saleCategory", "css"],
    queryFn: async () => {
      const { data } = await axios.get(`${baseurl}/getSaleCard-CSScategry`);
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const medicalQuery = useQuery({
    queryKey: ["saleCategory", "medical"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Medicalcategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const pashtoQuery = useQuery({
    queryKey: ["saleCategory", "pashto"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Pashtocategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const childrenQuery = useQuery({
    queryKey: ["saleCategory", "children"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Childrenocategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const ieltsQuery = useQuery({
    queryKey: ["saleCategory", "ielts"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-IELTScategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const aptitudeQuery = useQuery({
    queryKey: ["saleCategory", "aptitude"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Aptitudecategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  const islamicQuery = useQuery({
    queryKey: ["saleCategory", "islamic"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${baseurl}/getSaleCard-Islamiccategry`
      );
      return data?.data || [];
    },
    keepPreviousData: true,
  });
  const BaseURl = baseurl;

  const newArrivalQuery = useQuery({
    queryKey: ["newArrival"],
    queryFn: async () => {
      const { data } = await axios.get(`${baseurl}/GetNewArrival`);
      return data?.data || [];
    },
    keepPreviousData: true,
  });

  // Initialize with English results when available
  useEffect(() => {
    if (
      englishQuery.data &&
      (!filteredSaleCards || filteredSaleCards.length === 0)
    ) {
      setFilteredSaleCards(englishQuery.data);
    }
  }, [englishQuery.data]);

  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    if (category === "English books") {
      setFilteredSaleCards(englishQuery.data || []);
    } else if (category === "Urdu books") {
      setFilteredSaleCards(urduQuery.data || []);
    } else if (category === "Noval books") {
      setFilteredSaleCards(novalQuery.data || []);
    } else if (category === "Seasonal books") {
      setFilteredSaleCards(seasonalQuery.data || []);
    } else if (category === "CSS / PMS Books") {
      setFilteredSaleCards(cssQuery.data || []);
    } else if (category === "Medical Books") {
      setFilteredSaleCards(medicalQuery.data || []);
    } else if (category === "Pashto Books") {
      setFilteredSaleCards(pashtoQuery.data || []);
    } else if (category === "Children Books") {
      setFilteredSaleCards(childrenQuery.data || []);
    } else if (category === "IELTS/Toefl Books") {
      setFilteredSaleCards(ieltsQuery.data || []);
    } else if (category === "Aptitude test Books") {
      setFilteredSaleCards(aptitudeQuery.data || []);
    } else if (category === "Islamic Books") {
      setFilteredSaleCards(islamicQuery.data || []);
    } else if (category === "new arrival") {
      setFilteredSaleCards(newArrivalQuery.data || []);
    }

    // Add other categories if needed
  };
  const gotoCard = (id) => {
    if (selectedCategory === "new arrival") {
      navigate(`/arrival/${id}`);
    } else {
      navigate(`/buyTittle/${id}`);
    }
  };
  return (
    <>
      <Menu />
      <h1 className="text-xl font-bold items-center text-center">Products</h1>
      <div className="px-4 md:px-20  py-4 border flex justify-between">
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-7 text-sm md:text-base gap-y-3 font-serif font-bold  gap-x-8 cursor-pointer ">
          {/* <p
            className={`border-2 py-1 px-4 rounded-md ${selectedCategory === "All books" ? "bg-yellow-600 text-white text-center items-center" : "items-center text-center"
              }`}
            onClick={() => handleCategoryClick("All books")}
          >
            All books
          </p> */}
          <p
            className={`border-2 py-1 px-4 rounded-md ${
              selectedCategory === "English books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("English books")}
          >
            English books
          </p>
          <p
            className={`border-2 py-1 px-4 rounded-md ${
              selectedCategory === "Urdu books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Urdu books")}
          >
            Urdu books
          </p>
          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "Pashto Books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Pashto Books")}
          >
            Pashto Books
          </p>
          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "Islamic Books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Islamic Books")}
          >
            Islamic Books
          </p>
          <p
            className={`border-2 py-1 px-4 rounded-md ${
              selectedCategory === "Noval books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Noval books")}
          >
            Noval books
          </p>

          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "Medical Books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Medical Books")}
          >
            Medical Books
          </p>
          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "CSS / PMS Books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("CSS / PMS Books")}
          >
            CSS / PMS Books
          </p>

          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "Aptitude test Books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Aptitude test Books")}
          >
            Aptitude Test Books
          </p>

          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "IELTS/Toefl Books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("IELTS/Toefl Books")}
          >
            IELTS/Toefl Books
          </p>

          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "Children Books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Children Books")}
          >
            Children Books
          </p>

          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "Seasonal books"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("Seasonal books")}
          >
            Seasonal books
          </p>

          <p
            className={`border-2 py-1 px- rounded-md ${
              selectedCategory === "new arrival"
                ? "bg-yellow-600 text-white text-center items-center"
                : "items-center text-center"
            }`}
            onClick={() => handleCategoryClick("new arrival")}
          >
            New Arrival
          </p>
        </div>
      </div>
      <div className="pt-10 vedor-slider"></div>

      <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-5 md:gap-x-4 lg:gap-x-3 px-4 py-10">
        {/* Simple skeletons while loading the selected category */}
        {filteredSaleCards?.length === 0 && (
          <>
            {[...Array(4)].map((_, i) => (
              <div key={`skeleton-${i}`} className="animate-pulse">
                <div className="w-[200px] h-[230px] md:w-[300px] md:h-[300px] lg:w-[400px] lg:h-[400px] bg-slate-800/30 rounded" />
                <div className="mt-3 h-4 w-32 bg-slate-800/30 rounded" />
              </div>
            ))}
          </>
        )}
        {filteredSaleCards?.map((saleItem, index) => (
          <div key={index} className="w-full">
            <div className="w-full flex items-center justify-center cursor-pointer">
              <img
                src={saleItem.url}
                className="w-[200px] h-[230px] md:w-[300px] md:h-[300px] lg:w-[400px] lg:h-[400px]"
                alt=""
                onClick={() => gotoCard(saleItem._id)}
              />
            </div>

            <div className="flex flex-col justify-center items-center py-2">
              <h1 className="font-semibold text-xs sm:text-xs md:text-md lg:text-xl">
                {saleItem.title}
              </h1>
              <img src={review} alt="" className="pt-2 w-[70%] lg:w-[40%]" />
              <div className="flex gap-x-3">
                <h1
                  className={`${
                    saleItem.salePrice
                      ? "text-xs lg:text-lg text-gray-500 line-through"
                      : "text-xs lg:text-lg text-gray-500"
                  }`}
                >
                  Rs{saleItem.price}
                </h1>
                {saleItem.salePrice && (
                  <h1 className="text-xs lg:text-lg font-semibold">
                    Rs{saleItem.salePrice}
                  </h1>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
}
export default ProductPage;
